import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, tap, catchError, retry, timeout } from 'rxjs/operators';
import { environment } from '../../environments/environment';
// import { ConnectingUrlService } from '../Shared/connecting-url.service';
import { Observable, throwError } from 'rxjs';
import { ScrambleUnscrambleService } from './scramble-unscramble.service';

import { DeviceDetectorService } from 'ngx-device-detector';
import { ScrambleUnscramblestring } from '../Shared/scramble';

@Injectable({
  providedIn: 'root'
})
export class HttpServiceService {
  private serverUrl = '';
  private serverUrlDP = '';
  private folioUrl = '';
  // private serverUrl
  Path: any;
  public  scrambleKey = '';
  public  unscrambleKey = '';
  public  scrambleKey1 = '';
  public  unscrambleKey1 = '';

  public _localurl: String = "";
  public _qaturl: String = "";
  public _uaturl: String = "";
  public _motilalurl: String = "";
  public rendata;

  constructor(
    private http: HttpClient,
    private _scrambleUnscrambleString: ScrambleUnscrambleService,
    private deviceService: DeviceDetectorService,
    private ScrambleString: ScrambleUnscramblestring) {
    if (document.getElementById('ciphering') && document.getElementById('unciphering')) {
        const tempShielded = document.getElementById('ciphering').className;
        const tempUnShielded = document.getElementById('unciphering').className;
        const temppeShielded = document.getElementById('peciphering').className;
        const temppeUnShielded = document.getElementById('peunciphering').className;
        this.scrambleKey = this.getUnShieldedValuesFn(tempShielded);
        this.unscrambleKey = this.getUnShieldedValuesFn(tempUnShielded);
        this.scrambleKey1 = this.getUnShieldedValuesFn(temppeShielded);
        this.unscrambleKey1 = this.getUnShieldedValuesFn(temppeUnShielded);
      }

      if (this.scrambleKey && this.unscrambleKey && this.scrambleKey1 && this.unscrambleKey1 && document.querySelector(".ciphering-unciphering")) {
        document.querySelector(".ciphering-unciphering").remove();
      }
      console.log('this.serverUrl',this.serverUrl)
    this.serverUrl = atob(environment.url);
    this.serverUrlDP = atob(environment.urlDP);
    this.folioUrl = atob(environment.foiloapi);
    
    // this.getapiurl();

  }
 getUnShieldedValuesFn(inShieldedValue: string) {
      return String.fromCharCode(...inShieldedValue.split('.').reverse().map(re => +re));
    }
  // getapiurl() {

  //   this.http.get('../assets/url/url.txt', { responseType: 'text' }).subscribe(function (data) {

  //     const apiurl = JSON.parse(data);

  //     this._localurl = apiurl.local_url;

  //     this._qaturl = apiurl.qat_url

  //     this._uaturl = apiurl.uat_url;

  //     this._motilalurl = apiurl.motilal_url;

  //     // //console.log(this._localurl);

  //     this.Path = window.location.href
  //     let split = this.Path.split("/")
  //     let a = split[3];
  //     if (a == "motilal") {
  //       this.serverUrl = this._motilalurl;
  //     }
  //     else if (a == "centrum" || "abakkus") {
  //       this.serverUrl = this._uaturl;
  //     }
  //   }
  //     , error => {
  //       if (error.message.toUpperCase().includes("RXJS__WEBPACK_IMPORTED_MODULE_2__.OBSERVABLE.THROW IS NOT A FUNCTION")) {
  //         error = "We are unable to process your request at this time. Please try again later!"
  //       }
  //     }
  //   )
  // }



  getEmail(data): Observable<any> {
    let lockData1 = this._scrambleUnscrambleString.pefundApplyInternalFilter("Cloak", JSON.stringify(data), this.scrambleKey);
    let inputObj1 = { "data": lockData1 }
    return this.http.post(this.serverUrl, inputObj1).pipe(map((res) => {
      return res;
    }));
  }
  getfolio(data): Observable<any> {
    let lockData1 = this._scrambleUnscrambleString.pefundApplyInternalFilter("Cloak", JSON.stringify(data), this.scrambleKey1);
    let inputObj1 = { "data": lockData1}
    return this.http.post(this.serverUrlDP, inputObj1).pipe(map((res) => {
      return res;
    }));
  }
  generateOTP(data): Observable<any> {
    let lockData = this._scrambleUnscrambleString.pefundApplyInternalFilter("Cloak", JSON.stringify(data), this.scrambleKey);
    let inputObj = { "data": lockData }
    return this.http.post(this.serverUrl, inputObj).pipe(map((res) => {
      return res;
    }));
  }

  validateOTP(data): Observable<any> {
    let lockData = this._scrambleUnscrambleString.pefundApplyInternalFilter("Cloak", JSON.stringify(data), this.scrambleKey);
    let inputObj = { "data": lockData }
    return this.http.post(this.serverUrl, inputObj).pipe(map((res) => {
      return res;
    }));
  }

  getSubfundScheme(data): Observable<any> {
    let lockData = this._scrambleUnscrambleString.pefundApplyInternalFilter("Cloak", JSON.stringify(data), this.scrambleKey);
    let inputObj = { "data": lockData }
    return this.http.post(this.serverUrl, inputObj).pipe(map((res) => {
      return res;
    }));
  }

  getfortFolio(data): Observable<any> {
    let lockData = this._scrambleUnscrambleString.pefundApplyInternalFilter("Cloak", JSON.stringify(data), this.scrambleKey);
    let inputObj = { "data": lockData }
    return this.http.post(this.serverUrl, inputObj).pipe(map((res) => {
      return res;
    }));
  }

  getValuation(data): Observable<any> {
    let lockData = this._scrambleUnscrambleString.pefundApplyInternalFilter("Cloak", JSON.stringify(data), this.scrambleKey);
    let inputObj = { "data": lockData }
    return this.http.post(this.serverUrl, inputObj).pipe(map((res) => {
      return res;
    }));
  }

  getProfile(data): Observable<any> {
    let lockData = this._scrambleUnscrambleString.pefundApplyInternalFilter("Cloak", JSON.stringify(data), this.scrambleKey);
    let inputObj = { "data": lockData }
    return this.http.post(this.serverUrl, inputObj).pipe(map((res) => {
      return res;
    }));
  }

  getMenu(data): Observable<any> {
    let lockData = this._scrambleUnscrambleString.pefundApplyInternalFilter("Cloak", JSON.stringify(data), this.scrambleKey);
    let inputObj = { "data": lockData }
    return this.http.post(this.serverUrl, inputObj).pipe(map((res) => {
      return res;
    }));
  }

  getBlobData(data): Observable<any> {
    let lockData = this._scrambleUnscrambleString.pefundApplyInternalFilter("Cloak", JSON.stringify(data), this.scrambleKey);
    let inputObj = { "data": lockData }
    return this.http.post(this.serverUrl, inputObj).pipe(map((res) => {
      return res;
    }));
  }


  logout(data): Observable<any> {
    let lockData = this._scrambleUnscrambleString.pefundApplyInternalFilter("Cloak", JSON.stringify(data), this.scrambleKey);
    let inputObj = { "data": lockData }
    return this.http.post(this.serverUrl, inputObj).pipe(map((res) => {
      return res;
    }));
  }

  getOthers(data): Observable<any> {
    let lockData = this._scrambleUnscrambleString.pefundApplyInternalFilter("Cloak", JSON.stringify(data), this.scrambleKey);
    let inputObj = { "data": lockData }
    return this.http.post(this.serverUrl, inputObj).pipe(map((res) => {
      return res;
    }));
  }

  getQueries(data): Observable<any> {
    let lockData = this._scrambleUnscrambleString.pefundApplyInternalFilter("Cloak", JSON.stringify(data), this.scrambleKey);
    let inputObj = { "data": lockData }
    return this.http.post(this.serverUrl, inputObj).pipe(map((res) => {
      return res;
    }));
  }

  uploadQuery(data1): Observable<any> {
    let lockData = this._scrambleUnscrambleString.pefundApplyInternalFilter("Cloak", JSON.stringify(data1), this.scrambleKey);
    let inputObj = { "data": lockData }
    return this.http.post(this.serverUrl, inputObj).pipe(map((res) => {
      return res;
    }));
  }

  getcontactDetails(data1): Observable<any> {
    let lockData = this._scrambleUnscrambleString.pefundApplyInternalFilter("Cloak", JSON.stringify(data1), this.scrambleKey);
    let inputObj = { "data": lockData }
    return this.http.post(this.serverUrl, inputObj).pipe(map((res) => {
      return res;
    }));
  }
  getNAVDetails(data1): Observable<any> {
    let lockData = this._scrambleUnscrambleString.pefundApplyInternalFilter("Cloak", JSON.stringify(data1), this.scrambleKey);
    let inputObj = { "data": lockData }
    return this.http.post(this.serverUrl, inputObj).pipe(map((res) => {
      return res;
    }));
  }
  folio(data1): Observable<any> {
    let params = new HttpParams({
      fromObject: data1,
    });
   
    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
    };

    return this.http.post(this.folioUrl, params.toString(), {...options, responseType: "blob"}).pipe(
      map(
        (resp) => {
          return resp;
        },        (error) => {
          return error;
        }
      )
    );
  }
  getservicedata(credential, flag = '') {

    credential.browser = this.deviceService.getDeviceInfo().browser;
    credential.deviceid = this.deviceService.getDeviceInfo().browser_version;
    credential.osid = this.deviceService.getDeviceInfo().os_version;
    credential.application = "CAMSONLINE";

    if (flag)
      credential.sub_application = flag;
    else
      credential.sub_application = "WHITEOAKDP";

    // credential.sub_application = "WHITEOAKDP";

    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();
    if (isMobile) {
      credential.deviceid = "mobile";
    } else if (isTablet) {
      credential.deviceid = "tablet";
    } else if (isDesktopDevice) {
      credential.deviceid = "desktop";
    }
    // credential.page_name = this.router.url;
    let timeDelay = 60000;

    credential = this.ScrambleString.ApplyInternalFilter("Cloak", JSON.stringify(credential))
    // credential = this._scrambleUnscrambleString.pefundApplyInternalFilter("Cloak", JSON.stringify(credential), this.scrambleKey)
console.log(credential)
    return this.http.post<any>(this.serverUrlDP, { data: credential })
      .pipe(timeout(timeDelay), map(data => { //60000
        // return JSON.parse(this._scrambleUnscrambleString.pefundApplyInternalFilter("Unveil", data, this.scrambleKey));
console.log(data)
        return JSON.parse(this.ScrambleString.ClearInternalFilter("Unveil", data));
      }));

  }

}
